import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';
import { useAuth } from '../../../shared/useAuth.js';

// استجابة الخطأ من /export تأتي بنوع blob، فرسالة الخادم العربية مخفية داخله —
// نقرأ الـ blob ونستخرج error.message قبل عرض التنبيه.
async function unwrapBlobError(err) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      const msg = parsed?.error?.message;
      if (msg) {
        err.message = msg;
        err.response.data = parsed;
      }
    } catch { /* ليس JSON — نُبقي الرسالة كما هي */ }
  }
  return err;
}

export function useDownloadBackup() {
  return useApiMutation({
    mutationFn: async () => {
      // قد تكون النسخة كبيرة (صور الأطفال) — نلغي مهلة axios الافتراضية
      let res;
      try {
        res = await api.get('/backup/export', { responseType: 'blob', timeout: 0 });
      } catch (err) {
        throw await unwrapBlobError(err);
      }
      const dispo = res.headers['content-disposition'] || '';
      const m = dispo.match(/filename="?([^";]+)"?/);
      const name = m ? m[1] : `kidzo-backup-${new Date().toISOString().slice(0, 10)}.json.gz`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      return true;
    },
    successMessage: 'تم تنزيل النسخة الاحتياطية الكاملة'
  });
}

// حد حجم الملف على الخادم (nginx client_max_body_size + multer) — نتحقق قبل الرفع
// كي لا ينتظر المستخدم دقائق ثم يفشل بخطأ عام.
const MAX_RESTORE_BYTES = 200 * 1024 * 1024;

export function useRestoreBackup() {
  return useApiMutation({
    mutationFn: async (file) => {
      if (file.size > MAX_RESTORE_BYTES) {
        const err = new Error('حجم الملف أكبر من الحد المسموح (200MB). تأكد أنه ملف النسخة الاحتياطية الصحيح.');
        throw err;
      }
      const fd = new FormData();
      fd.append('file', file);
      fd.append('confirm', 'استعادة كاملة');
      try {
        const { data } = await api.post('/backup/import', fd, { timeout: 0 });
        return data;
      } catch (err) {
        if (err?.response?.status === 413) {
          err.message = 'الملف أكبر من الحد المسموح على الخادم — صغّر النسخة أو ارفع الحد في إعداد nginx.';
        }
        throw err;
      }
    },
    successMessage: 'تمت الاستعادة بنجاح — سيتم تسجيل خروجك الآن',
    // البيانات (بما فيها المستخدمون والجلسات) استُبدلت بالكامل ⇒ خروج وإعادة تحميل
    onSuccess: async () => {
      try { await useAuth.getState().logout(); } catch { /* ignore */ }
      setTimeout(() => { window.location.href = '/login'; }, 800);
    }
  });
}
